/**
 * @owner @Appboy/reporting
 * @fileoverview POST handler for the "/subscription_group_analytics/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { subscriptionGroupAnalyticsCacheKeys } from "./constants";
import type { SubscriptionGroupAnalyticsParams, SubscriptionGroupAnalyticsResult } from "./types";

export const postSubscriptionGroupAnalytics = reactQueryMutationAdapter(
  subscriptionGroupAnalyticsCacheKeys,
  (props: SubscriptionGroupAnalyticsParams): Promise<SubscriptionGroupAnalyticsResult> => {
    return fetch(`/subscription_group_analytics/${props.appGroupId}`, "POST", {
      start_date: props.startDate,
      end_date: props.endDate,
      channels: props.channels,
      subscription_group_id: props.subscriptionGroupId,
    });
  }
);
